/**
 * PA2 pluginにおけるfeature_codesのapiのキーをまとめた定数
 * PA2 のポイント残高取得機能のみを持つ
 * Ginger template optionで利用
 * */
export const PA2_FEATURE_CODES = {
  // ポイント取得機能
  GET_POINT_BALANCE: 'get_point_balance'
} as const;
